<template>
  <div class="screens-wrapper">
    <BankEmailForm
      v-if="!isSubstep"
      :car="car"
      :order-creation-error="orderCreationError"
      :order-creation-error-details="orderCreationErrorDetails"
      @startOrderProcess="startOrderProcess"
      :edit-mode="editMode"
    />
    <OrderDataForm
      v-else-if="isSubstep"
      :order="order"
      @updateOrderStep="(token, params) => updateOrderStep(token, params, '2a')"
      :edit-mode="editMode"
    />
  </div>
</template>

<script>
import BankEmailForm from '@/components/BankEmailForm';
import OrderDataForm from '@/components/OrderDataForm';

export default {
  components: {
    BankEmailForm,
    OrderDataForm,
  },
  props: ['car', 'order', 'startOrderProcess', 'updateOrderStep', 'currentOrderStep', 'isSubstep', 'orderCreationError', 'orderCreationErrorDetails', 'editMode'],
  data() {
    return {
      isEmailPassed: false,
    };
  },
  methods: {},
};
</script>
